/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { clientWorkspaceControllerActive } from '../fn/client-workspace/client-workspace-controller-active';
import { ClientWorkspaceControllerActive$Params } from '../fn/client-workspace/client-workspace-controller-active';
import { clientWorkspaceControllerCheckActiveClient } from '../fn/client-workspace/client-workspace-controller-check-active-client';
import { ClientWorkspaceControllerCheckActiveClient$Params } from '../fn/client-workspace/client-workspace-controller-check-active-client';
import { clientWorkspaceControllerCreate } from '../fn/client-workspace/client-workspace-controller-create';
import { ClientWorkspaceControllerCreate$Params } from '../fn/client-workspace/client-workspace-controller-create';
import { clientWorkspaceControllerDelete } from '../fn/client-workspace/client-workspace-controller-delete';
import { ClientWorkspaceControllerDelete$Params } from '../fn/client-workspace/client-workspace-controller-delete';
import { clientWorkspaceControllerDisconnect } from '../fn/client-workspace/client-workspace-controller-disconnect';
import { ClientWorkspaceControllerDisconnect$Params } from '../fn/client-workspace/client-workspace-controller-disconnect';
import { clientWorkspaceControllerFindAll } from '../fn/client-workspace/client-workspace-controller-find-all';
import { ClientWorkspaceControllerFindAll$Params } from '../fn/client-workspace/client-workspace-controller-find-all';
import { clientWorkspaceControllerFindAllByVendorWokrspaceId } from '../fn/client-workspace/client-workspace-controller-find-all-by-vendor-wokrspace-id';
import { ClientWorkspaceControllerFindAllByVendorWokrspaceId$Params } from '../fn/client-workspace/client-workspace-controller-find-all-by-vendor-wokrspace-id';
import { clientWorkspaceControllerFindById } from '../fn/client-workspace/client-workspace-controller-find-by-id';
import { ClientWorkspaceControllerFindById$Params } from '../fn/client-workspace/client-workspace-controller-find-by-id';
import { clientWorkspaceControllerFindByIdWithVendorWorkspaceId } from '../fn/client-workspace/client-workspace-controller-find-by-id-with-vendor-workspace-id';
import { ClientWorkspaceControllerFindByIdWithVendorWorkspaceId$Params } from '../fn/client-workspace/client-workspace-controller-find-by-id-with-vendor-workspace-id';
import { clientWorkspaceControllerGetInvitationCount } from '../fn/client-workspace/client-workspace-controller-get-invitation-count';
import { ClientWorkspaceControllerGetInvitationCount$Params } from '../fn/client-workspace/client-workspace-controller-get-invitation-count';
import { clientWorkspaceControllerGetMyClient } from '../fn/client-workspace/client-workspace-controller-get-my-client';
import { ClientWorkspaceControllerGetMyClient$Params } from '../fn/client-workspace/client-workspace-controller-get-my-client';
import { clientWorkspaceControllerSearchAllByNameOrBusinessNo } from '../fn/client-workspace/client-workspace-controller-search-all-by-name-or-business-no';
import { ClientWorkspaceControllerSearchAllByNameOrBusinessNo$Params } from '../fn/client-workspace/client-workspace-controller-search-all-by-name-or-business-no';
import { clientWorkspaceControllerSearchByNameOrBusinessNo } from '../fn/client-workspace/client-workspace-controller-search-by-name-or-business-no';
import { ClientWorkspaceControllerSearchByNameOrBusinessNo$Params } from '../fn/client-workspace/client-workspace-controller-search-by-name-or-business-no';
import { clientWorkspaceControllerSearchCursor } from '../fn/client-workspace/client-workspace-controller-search-cursor';
import { ClientWorkspaceControllerSearchCursor$Params } from '../fn/client-workspace/client-workspace-controller-search-cursor';
import { clientWorkspaceControllerSearchOffset } from '../fn/client-workspace/client-workspace-controller-search-offset';
import { ClientWorkspaceControllerSearchOffset$Params } from '../fn/client-workspace/client-workspace-controller-search-offset';
import { clientWorkspaceControllerUpdate } from '../fn/client-workspace/client-workspace-controller-update';
import { ClientWorkspaceControllerUpdate$Params } from '../fn/client-workspace/client-workspace-controller-update';
import { clientWorkspaceControllerValidateBusinessNo } from '../fn/client-workspace/client-workspace-controller-validate-business-no';
import { ClientWorkspaceControllerValidateBusinessNo$Params } from '../fn/client-workspace/client-workspace-controller-validate-business-no';
import { ClientWorkspaceDto } from '../models/client-workspace-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class ClientWorkspaceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `clientWorkspaceControllerFindAll()` */
  static readonly ClientWorkspaceControllerFindAllPath = '/api/clientWorkspace/all';

  /**
   * 모든 고객사 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerFindAll$Response(params?: ClientWorkspaceControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientWorkspaceDto>>> {
    return clientWorkspaceControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 고객사 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerFindAll(params?: ClientWorkspaceControllerFindAll$Params, context?: HttpContext): Observable<Array<ClientWorkspaceDto>> {
    return this.clientWorkspaceControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientWorkspaceDto>>): Array<ClientWorkspaceDto> => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceControllerSearchByNameOrBusinessNo()` */
  static readonly ClientWorkspaceControllerSearchByNameOrBusinessNoPath = '/api/clientWorkspace/search';

  /**
   * 고객사를 사업자등록번호 또는 기업명으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceControllerSearchByNameOrBusinessNo()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerSearchByNameOrBusinessNo$Response(params: ClientWorkspaceControllerSearchByNameOrBusinessNo$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceDto>> {
    return clientWorkspaceControllerSearchByNameOrBusinessNo(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사를 사업자등록번호 또는 기업명으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceControllerSearchByNameOrBusinessNo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerSearchByNameOrBusinessNo(params: ClientWorkspaceControllerSearchByNameOrBusinessNo$Params, context?: HttpContext): Observable<ClientWorkspaceDto> {
    return this.clientWorkspaceControllerSearchByNameOrBusinessNo$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientWorkspaceDto>): ClientWorkspaceDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceControllerValidateBusinessNo()` */
  static readonly ClientWorkspaceControllerValidateBusinessNoPath = '/api/clientWorkspace/businessNo';

  /**
   * 사업자 등록 정보 조회.
   *
   * 사용 가능한 사업자 등록 번호인지 조회합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceControllerValidateBusinessNo()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerValidateBusinessNo$Response(params: ClientWorkspaceControllerValidateBusinessNo$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return clientWorkspaceControllerValidateBusinessNo(this.http, this.rootUrl, params, context);
  }

  /**
   * 사업자 등록 정보 조회.
   *
   * 사용 가능한 사업자 등록 번호인지 조회합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceControllerValidateBusinessNo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerValidateBusinessNo(params: ClientWorkspaceControllerValidateBusinessNo$Params, context?: HttpContext): Observable<boolean> {
    return this.clientWorkspaceControllerValidateBusinessNo$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceControllerGetMyClient()` */
  static readonly ClientWorkspaceControllerGetMyClientPath = '/api/clientWorkspace/myClient';

  /**
   * 내 고객사 조회.
   *
   * 유저 ID를 기반으로 내 고객사를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceControllerGetMyClient()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerGetMyClient$Response(params?: ClientWorkspaceControllerGetMyClient$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceDto>> {
    return clientWorkspaceControllerGetMyClient(this.http, this.rootUrl, params, context);
  }

  /**
   * 내 고객사 조회.
   *
   * 유저 ID를 기반으로 내 고객사를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceControllerGetMyClient$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerGetMyClient(params?: ClientWorkspaceControllerGetMyClient$Params, context?: HttpContext): Observable<ClientWorkspaceDto> {
    return this.clientWorkspaceControllerGetMyClient$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientWorkspaceDto>): ClientWorkspaceDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceControllerCheckActiveClient()` */
  static readonly ClientWorkspaceControllerCheckActiveClientPath = '/api/clientWorkspace/{vendorWorkspaceId}/check-active';

  /**
   * 입점사 ID 기반 활성화된 고객사 조회
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceControllerCheckActiveClient()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerCheckActiveClient$Response(params: ClientWorkspaceControllerCheckActiveClient$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return clientWorkspaceControllerCheckActiveClient(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 ID 기반 활성화된 고객사 조회
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceControllerCheckActiveClient$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerCheckActiveClient(params: ClientWorkspaceControllerCheckActiveClient$Params, context?: HttpContext): Observable<boolean> {
    return this.clientWorkspaceControllerCheckActiveClient$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceControllerGetInvitationCount()` */
  static readonly ClientWorkspaceControllerGetInvitationCountPath = '/api/clientWorkspace/{id}/invitation-count';

  /**
   * 대기중인 초대/가입신청 내역 조회.
   *
   * 고객사 ID를 기반으로 대기중인 초대/가입신청 내역을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceControllerGetInvitationCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerGetInvitationCount$Response(params: ClientWorkspaceControllerGetInvitationCount$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return clientWorkspaceControllerGetInvitationCount(this.http, this.rootUrl, params, context);
  }

  /**
   * 대기중인 초대/가입신청 내역 조회.
   *
   * 고객사 ID를 기반으로 대기중인 초대/가입신청 내역을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceControllerGetInvitationCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerGetInvitationCount(params: ClientWorkspaceControllerGetInvitationCount$Params, context?: HttpContext): Observable<number> {
    return this.clientWorkspaceControllerGetInvitationCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceControllerFindAllByVendorWokrspaceId()` */
  static readonly ClientWorkspaceControllerFindAllByVendorWokrspaceIdPath = '/api/clientWorkspace/{id}/vendor';

  /**
   * 입점사 ID 기반 고객사 조회.
   *
   * 입점사 ID를 기반으로 고객사 목록을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceControllerFindAllByVendorWokrspaceId()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerFindAllByVendorWokrspaceId$Response(params: ClientWorkspaceControllerFindAllByVendorWokrspaceId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientWorkspaceDto>>> {
    return clientWorkspaceControllerFindAllByVendorWokrspaceId(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 ID 기반 고객사 조회.
   *
   * 입점사 ID를 기반으로 고객사 목록을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceControllerFindAllByVendorWokrspaceId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerFindAllByVendorWokrspaceId(params: ClientWorkspaceControllerFindAllByVendorWokrspaceId$Params, context?: HttpContext): Observable<Array<ClientWorkspaceDto>> {
    return this.clientWorkspaceControllerFindAllByVendorWokrspaceId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientWorkspaceDto>>): Array<ClientWorkspaceDto> => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceControllerFindById()` */
  static readonly ClientWorkspaceControllerFindByIdPath = '/api/clientWorkspace/{id}';

  /**
   * 고객사 ID 기반 조회.
   *
   * 고객사 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerFindById$Response(params: ClientWorkspaceControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceDto>> {
    return clientWorkspaceControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 ID 기반 조회.
   *
   * 고객사 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerFindById(params: ClientWorkspaceControllerFindById$Params, context?: HttpContext): Observable<ClientWorkspaceDto> {
    return this.clientWorkspaceControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientWorkspaceDto>): ClientWorkspaceDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceControllerDelete()` */
  static readonly ClientWorkspaceControllerDeletePath = '/api/clientWorkspace/{id}';

  /**
   * 고객사 삭제.
   *
   * 고객사를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerDelete$Response(params: ClientWorkspaceControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceDto>> {
    return clientWorkspaceControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 삭제.
   *
   * 고객사를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerDelete(params: ClientWorkspaceControllerDelete$Params, context?: HttpContext): Observable<ClientWorkspaceDto> {
    return this.clientWorkspaceControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientWorkspaceDto>): ClientWorkspaceDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceControllerUpdate()` */
  static readonly ClientWorkspaceControllerUpdatePath = '/api/clientWorkspace/{id}';

  /**
   * 고객사 수정.
   *
   * 고객사를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientWorkspaceControllerUpdate$Response(params: ClientWorkspaceControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceDto>> {
    return clientWorkspaceControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 수정.
   *
   * 고객사를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientWorkspaceControllerUpdate(params: ClientWorkspaceControllerUpdate$Params, context?: HttpContext): Observable<ClientWorkspaceDto> {
    return this.clientWorkspaceControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientWorkspaceDto>): ClientWorkspaceDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceControllerSearchAllByNameOrBusinessNo()` */
  static readonly ClientWorkspaceControllerSearchAllByNameOrBusinessNoPath = '/api/clientWorkspace/search/query';

  /**
   * 입점사 검색.
   *
   * 입점사 이름 또는 사업자 등록번호로 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceControllerSearchAllByNameOrBusinessNo()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerSearchAllByNameOrBusinessNo$Response(params: ClientWorkspaceControllerSearchAllByNameOrBusinessNo$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientWorkspaceDto>>> {
    return clientWorkspaceControllerSearchAllByNameOrBusinessNo(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 검색.
   *
   * 입점사 이름 또는 사업자 등록번호로 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceControllerSearchAllByNameOrBusinessNo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerSearchAllByNameOrBusinessNo(params: ClientWorkspaceControllerSearchAllByNameOrBusinessNo$Params, context?: HttpContext): Observable<Array<ClientWorkspaceDto>> {
    return this.clientWorkspaceControllerSearchAllByNameOrBusinessNo$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientWorkspaceDto>>): Array<ClientWorkspaceDto> => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceControllerSearchOffset()` */
  static readonly ClientWorkspaceControllerSearchOffsetPath = '/api/clientWorkspace/search/offset';

  /**
   * 고객사 오프셋 기반 검색.
   *
   * 고객사를 오프셋 기반으로 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerSearchOffset$Response(params: ClientWorkspaceControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return clientWorkspaceControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 오프셋 기반 검색.
   *
   * 고객사를 오프셋 기반으로 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerSearchOffset(params: ClientWorkspaceControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.clientWorkspaceControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceControllerSearchCursor()` */
  static readonly ClientWorkspaceControllerSearchCursorPath = '/api/clientWorkspace/search/cursor';

  /**
   * 고객사 커서 기반 검색.
   *
   * 고객사를 커서 기반으로 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerSearchCursor$Response(params: ClientWorkspaceControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return clientWorkspaceControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 커서 기반 검색.
   *
   * 고객사를 커서 기반으로 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerSearchCursor(params: ClientWorkspaceControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.clientWorkspaceControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceControllerFindByIdWithVendorWorkspaceId()` */
  static readonly ClientWorkspaceControllerFindByIdWithVendorWorkspaceIdPath = '/api/clientWorkspace/{id}/{vendorWorkspaceId}/vendor';

  /**
   * 고객사 ID / 입점사 ID 기반 조회.
   *
   * 고객사 ID와 입점사 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceControllerFindByIdWithVendorWorkspaceId()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerFindByIdWithVendorWorkspaceId$Response(params: ClientWorkspaceControllerFindByIdWithVendorWorkspaceId$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceDto>> {
    return clientWorkspaceControllerFindByIdWithVendorWorkspaceId(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 ID / 입점사 ID 기반 조회.
   *
   * 고객사 ID와 입점사 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceControllerFindByIdWithVendorWorkspaceId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerFindByIdWithVendorWorkspaceId(params: ClientWorkspaceControllerFindByIdWithVendorWorkspaceId$Params, context?: HttpContext): Observable<ClientWorkspaceDto> {
    return this.clientWorkspaceControllerFindByIdWithVendorWorkspaceId$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientWorkspaceDto>): ClientWorkspaceDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceControllerCreate()` */
  static readonly ClientWorkspaceControllerCreatePath = '/api/clientWorkspace/{vendorWorkspaceId}';

  /**
   * 고객사 생성.
   *
   * 고객사를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientWorkspaceControllerCreate$Response(params: ClientWorkspaceControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceDto>> {
    return clientWorkspaceControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 생성.
   *
   * 고객사를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientWorkspaceControllerCreate(params: ClientWorkspaceControllerCreate$Params, context?: HttpContext): Observable<ClientWorkspaceDto> {
    return this.clientWorkspaceControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientWorkspaceDto>): ClientWorkspaceDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceControllerActive()` */
  static readonly ClientWorkspaceControllerActivePath = '/api/clientWorkspace/{id}/active';

  /**
   * 고객사 활성화.
   *
   * 고객사를 활성화합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceControllerActive()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientWorkspaceControllerActive$Response(params: ClientWorkspaceControllerActive$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceDto>> {
    return clientWorkspaceControllerActive(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 활성화.
   *
   * 고객사를 활성화합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceControllerActive$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientWorkspaceControllerActive(params: ClientWorkspaceControllerActive$Params, context?: HttpContext): Observable<ClientWorkspaceDto> {
    return this.clientWorkspaceControllerActive$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientWorkspaceDto>): ClientWorkspaceDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceControllerDisconnect()` */
  static readonly ClientWorkspaceControllerDisconnectPath = '/api/clientWorkspace/{clientWorkspaceId}/{vendorWorkspaceId}/disconnect';

  /**
   * 고객사 연결 해제.
   *
   * 고객사와 입점사의 연결을 해제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceControllerDisconnect()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerDisconnect$Response(params: ClientWorkspaceControllerDisconnect$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceDto>> {
    return clientWorkspaceControllerDisconnect(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 연결 해제.
   *
   * 고객사와 입점사의 연결을 해제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceControllerDisconnect$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceControllerDisconnect(params: ClientWorkspaceControllerDisconnect$Params, context?: HttpContext): Observable<ClientWorkspaceDto> {
    return this.clientWorkspaceControllerDisconnect$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientWorkspaceDto>): ClientWorkspaceDto => r.body)
    );
  }

}
